import React from 'react'
import PlanCards from './PlanCards'

const Plans: React.FC = () => {
  return <PlanCards />
}

export default Plans